import { BundleSongState, BundleSongStatus } from 'services/store/ai/types';
import { TrackError, TrackLoader, TrackContent } from './components';

interface TrackProps {
  data: BundleSongState;
}

const Track = ({ data }: TrackProps) => {
  if (data.status === BundleSongStatus.LOADING) {
    return <TrackLoader />;
  }

  if (data.status === BundleSongStatus.ERROR) {
    return <TrackError />;
  }

  return <TrackContent song={data.song} />;
};

export default Track;
